import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Company, CoManageDataAccessObject } from '@safarilaw-webapp/feature/co-manage/data-access';

import { NavbarPermissionsService } from '@safarilaw-webapp/shared/app-bootstrap/data-access';
import { AuthService, PermissionsService } from '@safarilaw-webapp/shared/auth/store-access';
import { SafariObject } from '@safarilaw-webapp/shared/common-objects-models';

import { AppConfigurationService, FeatureFlagsService } from '@safarilaw-webapp/shared/environment';

@Injectable({
  providedIn: 'root'
})
export class LpmsNavbarPermissionsService extends NavbarPermissionsService {
  // Last-known-good MyCompany — the LPMS-only company gate. See the base class _currentUser field
  // for the full rationale; observeObject$ (default options) filters nulls, so this field only ever
  // holds a loaded company and is never cleared by an in-flight reload.
  private _currentCompany: Company | null = null;

  constructor(
    userPermissionService: PermissionsService,
    actions: Actions,
    store: Store<any>,
    featureFlags: FeatureFlagsService,
    authService: AuthService,
    appConfig: AppConfigurationService,
    coManageObject: CoManageDataAccessObject
  ) {
    super(userPermissionService, actions, store, featureFlags, authService, appConfig, coManageObject);
    this.dataApi.observeObject$(this.CoManageObject.MyCompany, SafariObject.NOID).subscribe(o => (this._currentCompany = o));
  }

  isServedDocumentManagerEnabled(): boolean {
    return this._currentCompany ? this._currentCompany.enableServedDocumentManager : false;
  }
  isTasksEnabled(): boolean {
    return this._currentCompany?.enableTasks == true;
  }
  isCurrentUserPciAuthorized(): boolean {
    return this._currentUser && this._currentCompany ? !this._currentCompany.enablePciCompliance || this._currentUser.canAccessPciData : false;
  }
  // SDM access (feature 12246 / 9704): the user-level flag that gates the SERVED DOC MANAGER nav
  // section. Per the API contract this flag only takes effect when the company has Served Document
  // Manager enabled, so it already encodes the company gate — no separate enableServedDocumentManager check needed here.
  canAccessIntakeEvents(): boolean {
    return this._currentUser ? this._currentUser.canAccessIntakeEvents === true : false;
  }
  // Gates the restructured Setup section (My Profile, System Settings, Subscriptions). When OFF the
  // new sub-items are filtered out and the legacy Setup header renders instead.
  isBlackMambaEnabled(): boolean {
    return this._featureFlags.enableBlackMamba;
  }
}
